document.addEventListener('DOMContentLoaded', async function () {
  const targetProductId = 9165628637429;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const itemsToRemove = cart.items.filter(item => item.product_id === targetProductId);

    if (itemsToRemove.length === 0) {
      console.log('✅ No hay productos con ese product_id en el carrito.');
      return;
    }

    console.log(`🔍 Se encontraron ${itemsToRemove.length} producto(s) con product_id ${targetProductId}. Procediendo a eliminar...`);

    for (const item of itemsToRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
      console.log(`🗑️ Producto eliminado → key: ${item.key}`);
    }

    console.log('✅ Todos los productos objetivo han sido eliminados del carrito.');

    setTimeout(() => {
      window.location.reload();
    }, 500);
    
  } catch (error) {
    console.error('❌ Error al eliminar productos del carrito:', error);
  }
});